// Libraries
import React from "react";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from "../../../routes/routes";
import { supportedLanguages } from "../../../i18n/supported-languages";
import phrasebookLoad from "../../../i18n";
import * as token from '../../../helpers/token';
import { accountTypesConstants } from '../../../constants';
import { capitalizeFirstLetter } from "../../../helpers/util"

// Redux
import { accountActions, functionalityActions, permissionActions } from 'actions';

// Components
import { NewBreadcrumbs } from "../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SubmitButton, CancelButton } from "../../../components/SkyFramework/Buttons";
import { Form } from "../../../components/SkyFramework/Forms";

// Constants
const phrasebook = phrasebookLoad()

class NotificationTypeAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      account_types: undefined,
      functionalities: undefined,
      account_type_id: undefined,
      functionality_id: undefined,
      read: false,
      list: false,
      write: false,
      edit: false,
      delete: false,
      submitted: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];

  }

  componentDidMount() {
    if (token.loggedAccountType() < 200) {
      this.props.dispatch(accountActions.getAllAccountTypes(0, this.state.page, { pccwglobal_account_type: true }));
    } else {
      this.props.dispatch(accountActions.getAllCustomerAccountTypes(0, this.state.page));
    }

    this.props.dispatch(functionalityActions.getAll(0, 0));

  }

  componentDidUpdate(prevProps) {
    if (this.props.account_types && prevProps && prevProps.account_types !== this.props.account_types) {
      this.setState({ account_types: this.props.account_types.account_types });
    }
    if (this.props.functionalities && prevProps && prevProps.functionalities !== this.props.functionalities) {
      this.setState({ functionalities: this.props.functionalities.functionalities });
    }
  }

  handleChange(e) {
    const { id, name, value, checked } = e.target;
    if (checked !== undefined) this.setState({ [id]: checked });
    else if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var newValues = {
      account_type_id: this.state.account_type_id,
      functionality_id: this.state.functionality_id,
      read: this.state.read,
      list: this.state.list,
      write: this.state.write,
      edit: this.state.edit,
      delete: this.state.delete
    }
    this.props.dispatch(permissionActions.add(newValues))
  }

  FormProfile = () => {
    if (this.state.account_types && this.state.functionalities) {

      const accountOptions = this.state.account_types.map(function (account_type) {
        return { value: account_type['id'], label: capitalizeFirstLetter(account_type['account_type']) };
      });
      const functionalitiesOptions = this.state.functionalities.map(function (functionality) {
        return { value: functionality['id'], label: `${capitalizeFirstLetter(functionality['category'])} ${capitalizeFirstLetter(functionality['sub_category'])}` };
      });


      const inputs = [
        { label: phrasebook.profile.account_type, type: "select", id: "account_type_id", name: "account_type_id", options: accountOptions, selected: this.state.account_type_id, empty_option: true },

        { label: phrasebook.headerlinks.functionality, type: "select", id: "functionality_id", name: "functionality_id", options: functionalitiesOptions, selected: this.state.functionality_id, empty_option: true },

        // phrasebook.common.single_read,
        // phrasebook.common.list,
        // phrasebook.common.create,
        // phrasebook.common.edit,
        // phrasebook.common.delete,
        { label: phrasebook.common.single_read, type: "checkbox", id: "read", name: "read" },
        { label: phrasebook.common.list, type: "checkbox", id: "list", name: "list" },
        { label: phrasebook.common.create, type: "checkbox", id: "write", name: "write" },
        { label: phrasebook.common.edit, type: "checkbox", id: "edit", name: "edit" },
        { label: phrasebook.common.delete, type: "checkbox", id: "delete", name: "delete" },
        // { label: phrasebook.profile.pccwglobal_link, type: "select", id: "pccwglobal_link_id", name: "pccwglobal_link_id", options: pccwglobalOptions, empty_option: true, selected: this.state.pccwglobal_link_id },
        // { label: phrasebook.common.website, type: "text", placeholder: this.state.website, id: "website", name: "website", value: this.state.website },
        // { label: phrasebook.profile.address, type: "select", id: "address_id", name: "address_id", options: addressOptions, empty_option: true, selected: this.state.address_id },
      ]
      const buttons = [<CancelButton title={phrasebook.common.back} link={gisRoutes.administration.permission.list} />, <SubmitButton title={phrasebook.common.add} />]
      return (
        <Form
          handleSubmit={this.handleSubmit}
          onChange={this.handleChange}
          title={`${phrasebook.common.add} ${phrasebook.headerlinks.permission}`}
          inputs={inputs}
          buttons={buttons}
        />)
    } else return null;
  }

  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.administration.notification_type.list, label: phrasebook.headerlinks.notification_types }]} current={`${phrasebook.common.add} ${phrasebook.headerlinks.notification_type}`} />
      {this.FormProfile()}
    </>
  }
}

function mapStateToProps(state) {
  const { loggedpermissions, account, authentication, functionality } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    account_types: account.account_types,
    functionalities: functionality.functionalities
  };
}


const notificationTypeAdd = connect(mapStateToProps)(NotificationTypeAdd);
export default (notificationTypeAdd);
